import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { NumberInThai } from '../utils/NumberHelper';

export function dateFormatter(cell, row){
  return moment(cell, "DD-MM-YYYY").format("DD/MM/YYYY");
}

export function issueNumberFormatter(cell, row){
  return _.isEmpty(cell) ? '####' : cell;
}

export function documentNumberFormatter(cell, row){
  return (
    <div>
      {row.workflow_name === "workflow_internal_receive" ? (
        <div>
          <div className='small'>{NumberInThai(row.prev_issue_number) || NumberInThai(row.issue_number)}</div>
          <div className='text-success xs-small'>เลขที่รับ: {NumberInThai(row.receive_number)}</div>
        </div>
      ) : (
        <div>{row.issue_number ? NumberInThai(row.issue_number) : "####"}</div>
      )}
    </div>
  )
}

export function receiveNumberFormatter(cell, row){
  return (
    <div>
      <div className='small'>{cell}</div>
      <div className='text-muted small'>เลขที่รับ: {NumberInThai(row.receive_number)}</div>
    </div>
  )
}

export function thaiDateFormatter(cell, row){
  if(_.isEmpty(cell)){ return ""; }

  if(cell.match("29/02/2567")){
    return "29/02/2567"
  }

  return moment(cell, "DD-MM-YYYY").format("DD/MM/YYYY");
}

export function informsFormatter(cell, row){
  return cell.map(inform => inform.position_name).join(", ");
}

export function draftTextFormatter(cell, row){
  return row.issue_number ? NumberInThai(row.issue_number) : "Draft";
}

export function dashFormatter(cell, row){
  return "-";
}

export function rowClassNameFormat(row, rowIndex){
  switch(row.speed_level) {
    case "ด่วน":
        return "td-white-space-normal hurry";
        break;
    case "ด่วนมาก":
        return "td-white-space-normal very-hurry";
        break;
    case "ด่วนที่สุด":
        return "td-white-space-normal urgent";
        break;
    default:
      return "td-white-space-normal";
  }
}

export function rowClassNameFormatWithUnread(row, rowIndex){
   let trClass = "td-white-space-normal"

  if(row.speed_level === 'ด่วน'){
    trClass = `${trClass} hurry`;
  } else if(row.speed_level === 'ด่วนมาก'){
    trClass = `${trClass} very-hurry`;
  } else if(row.speed_level === 'ด่วนที่สุด'){
    trClass = `${trClass} urgent`;
  }

  if(row.unread === true){
    trClass = `${trClass} unread`;
  }

  return trClass;
}

export function renderShowsTableTotal(start, to, total){
  return (
      <p style={ { color: 'blue' } }>
        แถวที่ { start } จาก { to } (ทั้งหมด { total } รายการ)
      </p>
    );
}



// WEBPACK FOOTER //
// ./src/utils/bootstrapTableFormatters.js